<template>
    <div>
        <div class="back" v-if="isVisible" @click="hideModal"></div>
        <div class="serviceView" v-if="isVisible">
            <div class="modalView_pop">
                <div class="modalView_pop_l">
                    <div class="modalView_pop_l_view">
                        <div class="modalView_pop_l_view_t">
                            <div class="modalView_pop_l_view_t_1">
                                <img class="modalView_pop_l_view_t_3_img" src="@/assets/images/modalView_pop_l_view_t_2_img.png" alt="">
                            </div>
                            <div class="modalView_pop_l_view_t_2">{{ $t('ChooseProduct.desc') }}</div>
                        </div>
                        <div class="modalView_pop_l_view_b">
                            <div class="modalView_pop_l_view_b_2">
                                <div class="modalView_pop_r_2_choose">
                                    <span class="modalView_pop_r_2_choose_span">{{ $t('ChooseProduct.Purchaser') }}:&nbsp;</span>
                                    <div class="modalView_pop_r_2_choose_v"
                                        @click="chooseType(item.value)"
                                        v-for="item in chooseList"
                                        :key="item.name"
                                    >
                                        <input 
                                            class="modalView_pop_r_2_choose_v_input" 
                                            type="radio" 
                                            name="product" 
                                            :value="item.value" 
                                            v-model="selectType"
                                        >
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="modalView_pop_l_view_b_2_info">
                                <el-form :model="formData" label-width="20%" :rules="rules" ref="formRef">
                                    <el-form-item :label="$t('ChooseProduct.companyName')" prop="company" v-if="selectType == '公司'">
                                        <el-autocomplete
                                            v-model="formData.company"
                                            :fetch-suggestions="querySearchAsync"
                                            :placeholder="$t('ChooseProduct.companyPlaceholder')"
                                            @select="handleSelect"
                                        >
                                        </el-autocomplete>
                                    </el-form-item>
                                    <el-form-item :label="$t('ChooseProduct.personName')" prop="name" v-else>
                                        <el-input v-model="formData.name" :placeholder="$t('ChooseProduct.personPlaceholder')"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('ChooseProduct.creditCode')" prop="creditCode" v-if="selectType == '公司'">
                                        <el-input v-model="formData.creditCode" :placeholder="$t('ChooseProduct.creditCodePlaceholder')"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('ChooseProduct.userPhone')" prop="user_phone">
                                        <el-input v-model="formData.user_phone" :placeholder="$t('ChooseProduct.userPhonePlaceholder')"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('ChooseProduct.address')" prop="address">
                                        <el-input v-model="formData.address" :placeholder="$t('ChooseProduct.addressPlaceholder')"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('ChooseProduct.resellerCode')" prop="reseller_code">
                                        <el-input v-model="formData.reseller_code" :placeholder="$t('ChooseProduct.resellerCodePlaceholder')"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="modalView_pop_l_view_b_2_btnView">
                                <div class="modalView_pop_l_view_b_2_btn" :class="$i18n.locale == 'en' ? 'noLetter' : ''" v-if="btnLoading" @click="submit">{{ $t('ChooseProduct.confirm') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { searchCompanies, getBaseinfo, createContractFile } from '@/api/index';
export default {
    data() {
        return {
            isVisible: false, // 控制弹窗的显示状态
            selectType: "公司", // 默认选择公司
            formData: {
                company: "",
                creditCode: "",
                name: "",
                user_phone: "",
                address: "",
                reseller_code: ""
            },
            rules: {
                company: [
                    { required: true, message: this.$t('ChooseProduct.companyPlaceholder'), trigger: 'blur' }
                ],
                creditCode: [
                    { required: true, message: this.$t('ChooseProduct.creditCodePlaceholder'), trigger: 'blur' }
                ],
                name: [
                    { required: true, message: this.$t('ChooseProduct.personPlaceholder'), trigger: 'blur' }
                ],
                user_phone: [
                    { required: true, message: this.$t('ChooseProduct.userPhonePlaceholder'), trigger: 'blur' }
                ],
                address: [
                    { required: true, message: this.$t('ChooseProduct.addressPlaceholder'), trigger: 'blur' }
                ],
            },
            formRef: null,
            btnLoading: true
        };
    },
    methods: {
        ...mapMutations(["setOrderInfo"]),
        showModal() {
            this.isVisible = true; // 显示弹窗
            document.body.style.overflow = 'hidden'; // 禁止页面滚动
        },
        hideModal() {
            this.isVisible = false; // 隐藏弹窗
            document.body.style.overflow = ''; // 恢复页面滚动
        },
        // 选择公司或个人
        chooseType(value) {
            this.selectType = value;
            // 重置表单数据
            this.resetFormData(value);
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate();
                }
            });
        },
        // 重置表单数据
        resetFormData(value) {
            if(value == "公司"){
                this.formData = {
                    name: "",
                    user_phone: "",
                    address: "",
                    reseller_code: ""
                };
            }else{
                this.formData = {
                    company: "",
                    creditCode: "",
                    user_phone: "",
                    address: "",
                    reseller_code: ""
                };
            }
        },
        // 异步查询搜索建议
        querySearchAsync(queryString, cb) {
            if (!queryString) {
                cb([]);
                return;
            }
            this.loading = true;
            // 调用后端接口获取搜索建议
            searchCompanies({
                keyword: queryString
            })
            .then(response => {
                this.loading = false;
                if (response.data && response.data.success) {
                    const list = [];
                    const suggestions = response.data.data || [];
                    suggestions.forEach(item => {
                        list.push({
                            value: item.name,
                            id: item.id
                        })
                    });
                    cb(list);
                } else {
                    console.log('查询失败', response.data);
                    cb([]);
                }
            })
            .catch(error => {
                this.loading = false;
                cb([]);
            });
        },
        // 处理选择建议
        handleSelect(item) {
            getBaseinfo({
                keyword: item.value
            }).then(res => {
                if (res.data.success) {
                    this.formData = {
                        company: res.data.data.name,
                        creditCode: res.data.data.creditCode,
                        user_phone: res.data.data.content ? res.data.data.content.phoneNumber : res.data.data.phoneNumber,
                        address: res.data.data.content ? res.data.data.content.regLocation : res.data.data.regLocation,
                    }
                }
            })
            // this.formData.company = item.value;
        },
        // 提交信息
        submit() {
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate();
                    this.$refs.formRef.validate((valid) => {
                        if (valid) {
                            this.btnLoading = false
                            //服务合同
                            // 根据 selectType 提交不同的数据
                            if (this.selectType == "公司") {
                                const params = {
                                    company: this.formData.company, //公司名称
                                    credit_code: this.formData.creditCode, //统一信用代码
                                    user_phone: this.formData.user_phone, //联系方式
                                    address: this.formData.address, //地址
                                    reseller_code: this.formData.reseller_code, //销售授权码
                                };
                                
                                // 只有当scope不为空时才添加scope相关参数
                                if (this.orderInfo.scope !== "" && this.orderInfo.scope !== null) {
                                    params.scope = this.orderInfo.scope; //盘查范围
                                    params.address_limit = Number(this.orderInfo.address_limit); //业务场所数量
                                    params.source_limit = this.orderInfo.source_limit; //排放源数量
                                    params.feature_code = "tpc"; //产品类型
                                } 
                                // 只有当use_limit不为空时才添加feature_code参数
                                else if (this.orderInfo.source_limit !== "" && this.orderInfo.source_limit !== null) {
                                    params.feature_code = "tzj"; //产品类型
                                    params.source_limit = this.orderInfo.source_limit; //使用量
                                }
                                // 默认情况
                                else {
                                    params.feature_code = "esg"; //产品类型
                                }
                                createContractFile(params).then(res => {
                                    if (res.data.size > 300) {
                                        this.$message({
                                            message: this.$t('ChooseProduct.contractSuccess'),
                                            type: 'success'
                                        });
                                        this.btnLoading = true
                                        const blob = new Blob([res.data], { type: 'application/pdf' });
                                        this.$emit('success', URL.createObjectURL(blob), this.formData);
                                        this.hideModal(); // 隐藏弹窗
                                        this.resetFormData(this.selectType); // 重置表单数据
                                    }else{
                                        const reader = new FileReader();
                                        reader.onload = () => {
                                            const errorInfo = JSON.parse(reader.result);
                                            this.$message({
                                                message: errorInfo.message,
                                                type: 'error'
                                            });
                                            this.btnLoading = true
                                        };
                                        reader.readAsText(res.data);
                                    }
                                })
                            } else if (this.selectType == "个人") {
                                const params = {
                                    company: this.formData.name, //姓名
                                    user_phone: this.formData.user_phone, //联系方式
                                    address: this.formData.address, //地址
                                    reseller_code: this.formData.reseller_code, //销售授权码
                                };
                                
                                // 只有当scope不为空时才添加scope相关参数
                                if (this.orderInfo.scope !== "" && this.orderInfo.scope !== null) {
                                    params.scope = this.orderInfo.scope; //盘查范围
                                    params.address_limit = Number(this.orderInfo.address_limit); //业务场所数量
                                    params.source_limit = this.orderInfo.source_limit; //排放源数量
                                    params.feature_code = "tpc"; //产品类型
                                } 
                                // 只有当use_limit不为空时才添加feature_code参数
                                else if (this.orderInfo.source_limit !== "" && this.orderInfo.source_limit !== null) {
                                    params.feature_code = "tzj"; //产品类型
                                    params.source_limit = this.orderInfo.source_limit; //使用量
                                }
                                // 默认情况
                                else {
                                    params.feature_code = "esg"; //产品类型
                                }
                                createContractFile(params).then(res => {
                                    if (res.data.size > 300) {
                                        this.$message({
                                            message: this.$t('ChooseProduct.contractSuccess'),
                                            type: 'success'
                                        });
                                        this.btnLoading = true
                                        const blob = new Blob([res.data], { type: 'application/pdf' });
                                        this.$emit('success', URL.createObjectURL(blob), this.formData);
                                        this.hideModal(); // 隐藏弹窗
                                        this.resetFormData(this.selectType); // 重置表单数据
                                    }else{
                                        const reader = new FileReader();
                                        reader.onload = () => {
                                            const errorInfo = JSON.parse(reader.result);
                                            this.$message({
                                                message: errorInfo.message,
                                                type: 'error'
                                            });
                                            this.btnLoading = true
                                        };
                                        reader.readAsText(res.data);
                                    }
                                })
                            }
                        } else {
                            this.btnLoading = true
                        }
                    });
                }
            })
        },
    },
    computed: {
        ...mapState(["userInfo", "orderInfo"]),
        chooseList() {
            return this.$t('ChooseProduct.chooseList');
        },
    },
    created() {
        this.$watch("isVisible", (val) => {
            if (val) {
                // 弹窗显示时的逻辑
            }
        });
    }
};
</script>

<style scoped lang="scss">
.back {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(33, 33, 33, 0.5);
    height: 100vh;
    z-index: 1004;
}
.serviceView {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
    background: var(--global-background);
    width: 945px;
    height: 650px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    z-index: 1005;

    .modalView_pop {
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        background-color: #ffffff;
        background-image: var(--global-inner-background);
        border-radius: 20px;
        display: flex;

        .modalView_pop_l {
            width: 920px;
            height: 100%;
            position: relative;

            .modalView_pop_l_view {
                width: 880px;
                height: 100%;
                margin: 0 10px 0 43px;
                border-left: 2px dashed #E3E6E8;

                .modalView_pop_l_view_t {
                    width: 100%;
                    border-bottom: 2px dashed #E3E6E8;
                    height: 140px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .modalView_pop_l_view_t_1 {
                        width: 223px;
                        height: 46px;
                        margin-left: 33px;

                        .modalView_pop_l_view_t_3_img {
                            width: 223px;
                            height: 46px;
                        }
                    }

                    .modalView_pop_l_view_t_2 {
                        font-size: 18px;
                        color: rgba(0, 0, 0, 1);
                        font-weight: 500;
                        margin-left: 35px;
                        letter-spacing: 3px;
                    }
                }

                .modalView_pop_l_view_b {
                    width: 100%;
                    height: calc(100% - 180px);
                    position: relative;

                    .modalView_pop_l_view_b_2 {
                        margin: 38px 10px 30px 33px;
                        height: auto;
                        overflow-y: hidden;

                        .modalView_pop_r_2_choose {
                            height: 40px;
                            width: 100%;
                            display: flex;
                            align-items: center;

                            .modalView_pop_r_2_choose_span{
                                font-size: 20px;
                                margin-right: 10px;
                                font-weight: 600;
                            }

                            .modalView_pop_r_2_choose_v {
                                height: 100%;
                                display: flex;
                                align-items: center;
                                margin-right: 50px;

                                .modalView_pop_r_2_choose_v_input {
                                    appearance: none;
                                    width: 25px;
                                    height: 25px;
                                    border: 1px solid #757575;
                                    border-radius: 50%;
                                    margin-right: 10px;
                                    position: relative;
                                    cursor: pointer;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                }

                                .modalView_pop_r_2_choose_v_input:checked {
                                    border-color: #757575;
                                    background-color: #fff;
                                }

                                ::v-deep .modalView_pop_r_2_choose_v_input:checked:after {
                                    content: '';
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    width: 17px !important;
                                    height: 17px !important;
                                    border-radius: 50%;
                                    background-color: #757575;
                                }

                                span {
                                    font-size: 20px;
                                    font-weight: 700;
                                    color: rgba(0, 0, 0, 1);
                                }
                            }
                        }
                    }

                    .modalView_pop_l_view_b_2_info {
                        height: 300px;
                        margin: 0px 55px 0px 33px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .el-form {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-start;

                            .el-form-item {
                                margin-bottom: 20px;
                                font-size: 20px;

                                ::v-deep .el-form-item__label {
                                    font-size: 20px;
                                    text-align: left;
                                }

                                .el-input, 
                                .el-autocomplete {
                                    width: 100%;
                                    height: 40px;
                                    font-size: 16px;
                                    color: rgba(0, 0, 0, 1);
                                }
                            }
                        }
                    }

                    .modalView_pop_l_view_b_2_btnView {
                        width: 100%;
                        height: 45px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .modalView_pop_l_view_b_2_btn {
                            width: 300px;
                            height: 45px;
                            // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                            background: var(--global-primary);
                            border-radius: 16px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #fff;
                            font-size: 22px;
                            font-weight: 700;
                            cursor: pointer;
                            letter-spacing: 10px;
                        }

                        .noLetter{
                            letter-spacing: 0px!important;
                        }
                    }
                }
            }
        }
    }
}
</style>